export const placeTourModes = [
    {
        id: 'family-arc',
        labelKey: 'placeMap.tour.modes.familyArc.label',
        descriptionKey: 'placeMap.tour.modes.familyArc.description',
        stopIds: [
            'old-world-roots',
            'veluwe-home',
            'amsterdam-harbor',
            'batavia-gateway',
            'java-corridor',
            'east-java',
            'moluccan-arc',
        ],
    },
    {
        id: 'indies-crossing',
        labelKey: 'placeMap.tour.modes.indiesCrossing.label',
        descriptionKey: 'placeMap.tour.modes.indiesCrossing.description',
        stopIds: [
            'batavia-gateway',
            'java-corridor',
            'bandung-highlands',
            'east-java',
            'malang-uplands',
            'moluccan-arc',
        ],
    },
    {
        id: 'memory-line',
        labelKey: 'placeMap.tour.modes.memoryLine.label',
        descriptionKey: 'placeMap.tour.modes.memoryLine.description',
        stopIds: [
            'amsterdam-harbor',
            'batavia-gateway',
            'bandung-highlands',
            'cimahi-memory',
            'moluccan-arc',
        ],
    },
];

export const placeTourStops = [
    {
        id: 'old-world-roots',
        placeGroupId: 'erstein',
        eraKey: 'placeMap.tour.eras.europeanRoots',
        oldNameKey: 'placeMap.tour.oldNames.erstein',
        fallbackCenter: [7.66, 48.42],
        closeZoom: 15.6,
        titleKey: 'placeMap.tour.stops.oldWorldRoots.title',
        summaryKey: 'placeMap.tour.stops.oldWorldRoots.summary',
        statsLabelKey: 'placeMap.tour.stops.oldWorldRoots.statsLabel',
        timeline: [
            { type: 'approach', center: [7.2, 48.15], zoom: 5.0, pitch: 24, bearing: -18, duration: 2800 },
            { type: 'dive', center: [7.66, 48.42], zoom: 11.7, pitch: 66, bearing: -28, duration: 4200 },
            { type: 'diorama', center: [7.66, 48.42], zoom: 15.6, pitch: 73, bearing: -52, duration: 3600 },
            { type: 'orbit', bearingDelta: 28, duration: 3600 },
        ],
    },
    {
        id: 'veluwe-home',
        placeGroupId: 'oldebroek',
        eraKey: 'placeMap.tour.eras.veluwe',
        oldNameKey: 'placeMap.tour.oldNames.oldebroek',
        fallbackCenter: [5.90, 52.45],
        closeZoom: 15.3,
        titleKey: 'placeMap.tour.stops.veluweHome.title',
        summaryKey: 'placeMap.tour.stops.veluweHome.summary',
        statsLabelKey: 'placeMap.tour.stops.veluweHome.statsLabel',
        timeline: [
            { type: 'approach', center: [5.2, 52.15], zoom: 5.5, pitch: 22, bearing: 20, duration: 2600 },
            { type: 'dive', center: [5.90, 52.45], zoom: 11.2, pitch: 64, bearing: 34, duration: 3900 },
            { type: 'diorama', center: [5.90, 52.45], zoom: 15.3, pitch: 72, bearing: 58, duration: 3600 },
            { type: 'orbit', bearingDelta: -34, duration: 3600 },
        ],
    },
    {
        id: 'amsterdam-harbor',
        placeGroupId: 'amsterdam',
        eraKey: 'placeMap.tour.eras.harbor',
        oldNameKey: 'placeMap.tour.oldNames.amsterdam',
        fallbackCenter: [4.90, 52.37],
        closeZoom: 15.8,
        titleKey: 'placeMap.tour.stops.amsterdamHarbor.title',
        summaryKey: 'placeMap.tour.stops.amsterdamHarbor.summary',
        statsLabelKey: 'placeMap.tour.stops.amsterdamHarbor.statsLabel',
        timeline: [
            { type: 'approach', center: [3.9, 52.05], zoom: 5.6, pitch: 26, bearing: -42, duration: 2800 },
            { type: 'dive', center: [4.90, 52.37], zoom: 11.4, pitch: 66, bearing: -40, duration: 4100 },
            { type: 'diorama', center: [4.90, 52.37], zoom: 15.8, pitch: 73, bearing: -82, duration: 3600 },
            { type: 'orbit', bearingDelta: 32, duration: 3600 },
        ],
    },
    {
        id: 'batavia-gateway',
        placeGroupId: 'jakarta',
        eraKey: 'placeMap.tour.eras.batavia',
        oldNameKey: 'placeMap.tour.oldNames.jakarta',
        fallbackCenter: [106.83, -6.18],
        closeZoom: 15.6,
        titleKey: 'placeMap.tour.stops.bataviaGateway.title',
        summaryKey: 'placeMap.tour.stops.bataviaGateway.summary',
        statsLabelKey: 'placeMap.tour.stops.bataviaGateway.statsLabel',
        timeline: [
            { type: 'approach', center: [105.8, -5.55], zoom: 4.6, pitch: 25, bearing: 24, duration: 3200 },
            { type: 'dive', center: [106.83, -6.18], zoom: 10.8, pitch: 66, bearing: 28, duration: 4600 },
            { type: 'diorama', center: [106.83, -6.18], zoom: 15.6, pitch: 74, bearing: 58, duration: 3900 },
            { type: 'orbit', bearingDelta: -30, duration: 3800 },
        ],
    },
    {
        id: 'java-corridor',
        placeGroupId: 'semarang',
        eraKey: 'placeMap.tour.eras.javaCoast',
        oldNameKey: 'placeMap.tour.oldNames.semarang',
        fallbackCenter: [110.42, -6.99],
        closeZoom: 15.4,
        titleKey: 'placeMap.tour.stops.javaCorridor.title',
        summaryKey: 'placeMap.tour.stops.javaCorridor.summary',
        statsLabelKey: 'placeMap.tour.stops.javaCorridor.statsLabel',
        timeline: [
            { type: 'approach', center: [110.1, -6.45], zoom: 5.4, pitch: 26, bearing: 84, duration: 3000 },
            { type: 'dive', center: [110.42, -6.99], zoom: 10.9, pitch: 67, bearing: 96, duration: 4200 },
            { type: 'diorama', center: [110.42, -6.99], zoom: 15.4, pitch: 73, bearing: 132, duration: 3700 },
            { type: 'orbit', bearingDelta: -30, duration: 3600 },
        ],
    },
    {
        id: 'bandung-highlands',
        placeGroupId: 'bandung',
        eraKey: 'placeMap.tour.eras.preanger',
        oldNameKey: 'placeMap.tour.oldNames.bandung',
        fallbackCenter: [107.61, -6.91],
        closeZoom: 15.8,
        titleKey: 'placeMap.tour.stops.bandungHighlands.title',
        summaryKey: 'placeMap.tour.stops.bandungHighlands.summary',
        statsLabelKey: 'placeMap.tour.stops.bandungHighlands.statsLabel',
        timeline: [
            { type: 'approach', center: [107.2, -6.55], zoom: 6.0, pitch: 32, bearing: -18, duration: 2800 },
            { type: 'dive', center: [107.61, -6.91], zoom: 11.5, pitch: 68, bearing: -36, duration: 4000 },
            { type: 'diorama', center: [107.61, -6.91], zoom: 15.8, pitch: 74, bearing: -68, duration: 3700 },
            { type: 'orbit', bearingDelta: 34, duration: 3600 },
        ],
    },
    {
        id: 'cimahi-memory',
        placeGroupId: 'cimahi',
        eraKey: 'placeMap.tour.eras.memory',
        oldNameKey: 'placeMap.tour.oldNames.cimahi',
        fallbackCenter: [107.54, -6.88],
        closeZoom: 15.9,
        titleKey: 'placeMap.tour.stops.cimahiMemory.title',
        summaryKey: 'placeMap.tour.stops.cimahiMemory.summary',
        statsLabelKey: 'placeMap.tour.stops.cimahiMemory.statsLabel',
        timeline: [
            { type: 'approach', center: [107.15, -6.60], zoom: 6.2, pitch: 30, bearing: -8, duration: 2600 },
            { type: 'dive', center: [107.54, -6.88], zoom: 12.0, pitch: 68, bearing: -24, duration: 3900 },
            { type: 'diorama', center: [107.54, -6.88], zoom: 15.9, pitch: 75, bearing: -54, duration: 3800 },
            { type: 'orbit', bearingDelta: 26, duration: 3600 },
        ],
    },
    {
        id: 'east-java',
        placeGroupId: 'surabaya',
        eraKey: 'placeMap.tour.eras.eastJava',
        oldNameKey: 'placeMap.tour.oldNames.surabaya',
        fallbackCenter: [112.75, -7.26],
        closeZoom: 15.7,
        titleKey: 'placeMap.tour.stops.eastJava.title',
        summaryKey: 'placeMap.tour.stops.eastJava.summary',
        statsLabelKey: 'placeMap.tour.stops.eastJava.statsLabel',
        timeline: [
            { type: 'approach', center: [112.4, -6.80], zoom: 5.5, pitch: 26, bearing: 118, duration: 3000 },
            { type: 'dive', center: [112.75, -7.26], zoom: 11.2, pitch: 67, bearing: 128, duration: 4200 },
            { type: 'diorama', center: [112.75, -7.26], zoom: 15.7, pitch: 74, bearing: 156, duration: 3800 },
            { type: 'orbit', bearingDelta: -28, duration: 3600 },
        ],
    },
    {
        id: 'malang-uplands',
        placeGroupId: 'malang',
        eraKey: 'placeMap.tour.eras.uplands',
        oldNameKey: 'placeMap.tour.oldNames.malang',
        fallbackCenter: [112.63, -7.98],
        closeZoom: 15.5,
        titleKey: 'placeMap.tour.stops.malangUplands.title',
        summaryKey: 'placeMap.tour.stops.malangUplands.summary',
        statsLabelKey: 'placeMap.tour.stops.malangUplands.statsLabel',
        timeline: [
            { type: 'approach', center: [112.35, -7.55], zoom: 6.0, pitch: 34, bearing: 126, duration: 2700 },
            { type: 'dive', center: [112.63, -7.98], zoom: 11.6, pitch: 69, bearing: 142, duration: 4000 },
            { type: 'diorama', center: [112.63, -7.98], zoom: 15.5, pitch: 74, bearing: 172, duration: 3600 },
            { type: 'orbit', bearingDelta: -32, duration: 3600 },
        ],
    },
    {
        id: 'moluccan-arc',
        placeGroupId: 'amboina',
        eraKey: 'placeMap.tour.eras.moluccas',
        oldNameKey: 'placeMap.tour.oldNames.amboina',
        fallbackCenter: [128.19, -3.70],
        closeZoom: 14.7,
        titleKey: 'placeMap.tour.stops.moluccanArc.title',
        summaryKey: 'placeMap.tour.stops.moluccanArc.summary',
        statsLabelKey: 'placeMap.tour.stops.moluccanArc.statsLabel',
        timeline: [
            { type: 'approach', center: [126.5, -3.05], zoom: 4.4, pitch: 28, bearing: -72, duration: 3400 },
            { type: 'dive', center: [128.19, -3.70], zoom: 9.8, pitch: 63, bearing: -78, duration: 4800 },
            { type: 'diorama', center: [128.19, -3.70], zoom: 14.7, pitch: 72, bearing: -112, duration: 4100 },
            { type: 'orbit', bearingDelta: 36, duration: 3900 },
        ],
    },
];

export default placeTourStops;
